"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function isCaseOpen(serviceCase) {
  // TODO: CORE Replace this method with the one in app client AFTER new Core merge
  // https://uniteus.atlassian.net/browse/CORE-899
  if ((0, _lodash.has)(serviceCase, 'outcome')) {
    return (0, _lodash.isEmpty)(serviceCase.outcome);
  }
  return (0, _lodash.isNull)(serviceCase.closing || serviceCase.closed_at);
}
var _default = exports["default"] = isCaseOpen;